export enum ELoggedInUserType {
  AccountAdmin = "ADMIN",
  AccountUser = "USER",
  Employee = "EMPLOYEE",
  EsAccUser = "ESUSER",
  AccountManager = "ACCOUNT_MANAGER",
}